import { render, staticRenderFns } from "./preferred-educator-card.vue?vue&type=template&id=e771d2d6&scoped=true&"
import script from "./preferred-educator-card.vue?vue&type=script&lang=js&"
export * from "./preferred-educator-card.vue?vue&type=script&lang=js&"
import style0 from "./preferred-educator-card.vue?vue&type=style&index=0&id=e771d2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e771d2d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
